const SKELETON_WIDTHS = [85, 92, 70, 88, 76, 90, 80, 86, 72, 94]

export interface ChatListSkeletonProps {
  count?: number
}

export function ChatListSkeleton({ count = 10 }: ChatListSkeletonProps) {
  return (
    <div className="flex flex-col gap-3 py-1 pl-7 pr-3">
      {SKELETON_WIDTHS.slice(0, count).map((width, i) => (
        <div
          key={i}
          className="h-2.5 rounded-sm bg-neutral-800 animate-pulse"
          style={{ width: `${width}%` }}
        />
      ))}
    </div>
  )
}
